import React, { useEffect, useState } from "react";
import JobCard from "../Jobs/JobCard";
import CandidatePageShell from "./CandidatePageShell";
import useFetch from "../../useFetch";
import { formatDate, mapApiJob } from "../../utils/jobFormatters";
import Pagination from "../Pagination";

const CandidateAppliedJobs = () => {
  const perPage = 10;
  const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);
  const [meta, setMeta] = useState({});
  const { response, isLoading, error } = useFetch(process.env.REACT_APP_BASE_API_URL + `/candidate/applications?per_page=${perPage}&page=${page}`);

  useEffect(() => {
    setItems(response?.applications?.data ?? []);
    setMeta(response?.applications?.meta ?? {});
  }, [response]);

  const applicationStatusLabel = (application) => {
    if (application?.submission_status === "pending_verification") {
      return "pending email verification";
    }

    return application?.status;
  };

  const renderApplicationJob = (application) => {
    const mappedJob = mapApiJob(application.job, { time: `Applied ${formatDate(application.created_at)}` });

    return mappedJob ? (
      <JobCard job={mappedJob} />
    ) : (
      <div className="employee-empty-state">This job is no longer available.</div>
    );
  };

  return (
    <CandidatePageShell
      active="applied"
      title="Applied Jobs"
      text="Jobs you have applied to through Epic-Jobs."
    >
      <div className="ls-widget">
        <div className="widget-title">
          <h4>Application History</h4>
        </div>
        <div className="widget-content">
          {error && <div className="alert alert-danger"><strong>{error}</strong></div>}
          {isLoading && <h5 className="text-center my-3">Loading Data</h5>}

          <div className="row">
            {!error && !isLoading && items.map((application) => (
              <div className="col-lg-6 col-md-12 col-sm-12 candidate-job-card" key={application.id}>
                {renderApplicationJob(application)}
                <div className="candidate-job-status">
                  <span className={application.status === "shortlisted" ? "success" : ""}>{applicationStatusLabel(application)}</span>
                  <span>{application.resume_original_name ?? "Resume attached"}</span>
                </div>
              </div>
            ))}
          </div>

          {!error && !isLoading && items.length === 0 && (
            <div className="employee-empty-state">You have not applied to any jobs yet.</div>
          )}

          {!error && !isLoading && meta?.total > 0 && (
            <i className="d-block text-center">({meta.total} applications found)</i>
          )}
          {!error && !isLoading && <Pagination meta={meta} onPageChange={setPage} label="Applied jobs pagination" />}
        </div>
      </div>
    </CandidatePageShell>
  );
};

export default CandidateAppliedJobs;
